export default "<template>\n\n  <KButton\n    primary\n    text=\"Raised Button\"\n  />\n\n</template>\n";